<template>
  <button
    type="button"
    class="primery-button"
    :disabled="isSubmitting"
    @click="handleSend"
  >
    {{ $t('button.send') }}
  </button>
</template>

<script>
export default {
  name: 'FormSendButton',
  props: {
    formData: {
      type: Object,
      required: true
    },
    errors: {
      type: Object,
      required: true
    },
    isSubmitting: {
      type: Boolean,
      required: true
    },
    validateForm: {
      type: Function,
      required: true
    },
    onSuccess: {
      type: Function,
      required: true
    },
    onError: {
      type: Function,
      required: true
    }
  },
  methods: {
    async handleSend() {
      if (this.isSubmitting) return;

      const isValid = this.validateForm();
      if (!isValid) {
        this.onError('Invalid form data');
        return;
      }

      const formData = new FormData();
      for (const key in this.formData) {
        formData.append(key, this.formData[key]);
      }

      try {
        const response = await fetch('/public/send.php', {
          method: 'POST',
          body: formData
        });

        if (response.ok) {
          this.onSuccess();
        } else {
          this.onError(`Server error: ${response.statusText}`);
        }
      } catch (error) {
        this.onError(`Network error: ${error.message}`);
      }
    }
  }
};
</script>
